var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"mb-3",class:`${_vm.classString? _vm.classString : ''} icons-svg `,attrs:{"src":require(`./icons/${_vm.icon}-icon.svg`)}})
}
var staticRenderFns = []

export { render, staticRenderFns }